// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tree connector lines ─────────────────────────────────────────────────── */
.stree-children {
    list-style: none;
    margin: 0;
    padding: 2px 0 0 20px;
}

/* spacing between root-level items (no connectors) */
.stree-root {
    padding-left: 0;
}

.stree-root > .stree-item {
    padding-top: 0;
    margin-bottom: 6px;
}

.stree-root > .stree-item::before,
.stree-root > .stree-item::after {
    display: none;
}

.stree-item {
    position: relative;
    padding-top: 6px;
}

/* Vertical line — runs full height for non-last siblings */
.stree-item:not(:last-child)::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #d3d3d3;
}

/* Vertical line — stops at pill centre for last sibling (L-shape) */
.stree-item:last-child::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 0;
    height: 17px;
    width: 2px;
    background: #d3d3d3;
}

/* Horizontal elbow */
.stree-item::after {
    content: '';
    position: absolute;
    left: -20px;
    top: 17px;
    width: 14px;
    height: 2px;
    background: #d3d3d3;
}

/* ── Collection pill ──────────────────────────────────────────────────────── */
.stree-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(38, 144, 68, 0.07);
    border: 1px solid rgba(38, 144, 68, 0.28);
    border-radius: 5px;
    padding: 4px 10px 4px 7px;
    font-size: 12px;
    color: #269044;
    font-weight: 600;
    cursor: default;
    -webkit-user-select: none;
            user-select: none;
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.stree-pill:hover {
    background: rgba(38, 144, 68, 0.14);
    border-color: rgba(38, 144, 68, 0.5);
    box-shadow: 0 1px 5px rgba(38, 144, 68, 0.13);
}

/* Muted child-count inside pill */
.stree-count {
    font-size: 10px;
    font-weight: 500;
    color: rgba(38, 144, 68, 0.55);
    letter-spacing: 0.01em;
}

/* ── Property count badge ─────────────────────────────────────────────────── */
.stree-prop-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #f3f3f3;
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    padding: 3px 9px;
    font-size: 11px;
    color: #909090;
    font-weight: 600;
    cursor: default;
    -webkit-user-select: none;
            user-select: none;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.stree-prop-badge:hover {
    background: #eaeaea;
    border-color: #bbb;
    color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/Tree.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;IACI,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA,qDAAqD;AACrD;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,2DAA2D;AAC3D;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA,oEAAoE;AACpE;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,iFAAiF;AACrF;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA,kCAAkC;AAClC;IACI,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA,gFAAgF;AAChF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,0DAA0D;AAC9D;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["/* ── Tree connector lines ─────────────────────────────────────────────────── */\r\n.stree-children {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 2px 0 0 20px;\r\n}\r\n\r\n/* spacing between root-level items (no connectors) */\r\n.stree-root {\r\n    padding-left: 0;\r\n}\r\n\r\n.stree-root > .stree-item {\r\n    padding-top: 0;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.stree-root > .stree-item::before,\r\n.stree-root > .stree-item::after {\r\n    display: none;\r\n}\r\n\r\n.stree-item {\r\n    position: relative;\r\n    padding-top: 6px;\r\n}\r\n\r\n/* Vertical line — runs full height for non-last siblings */\r\n.stree-item:not(:last-child)::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: -20px;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 2px;\r\n    background: #d3d3d3;\r\n}\r\n\r\n/* Vertical line — stops at pill centre for last sibling (L-shape) */\r\n.stree-item:last-child::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: -20px;\r\n    top: 0;\r\n    height: 17px;\r\n    width: 2px;\r\n    background: #d3d3d3;\r\n}\r\n\r\n/* Horizontal elbow */\r\n.stree-item::after {\r\n    content: '';\r\n    position: absolute;\r\n    left: -20px;\r\n    top: 17px;\r\n    width: 14px;\r\n    height: 2px;\r\n    background: #d3d3d3;\r\n}\r\n\r\n/* ── Collection pill ──────────────────────────────────────────────────────── */\r\n.stree-pill {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    background: rgba(38, 144, 68, 0.07);\r\n    border: 1px solid rgba(38, 144, 68, 0.28);\r\n    border-radius: 5px;\r\n    padding: 4px 10px 4px 7px;\r\n    font-size: 12px;\r\n    color: #269044;\r\n    font-weight: 600;\r\n    cursor: default;\r\n    user-select: none;\r\n    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.stree-pill:hover {\r\n    background: rgba(38, 144, 68, 0.14);\r\n    border-color: rgba(38, 144, 68, 0.5);\r\n    box-shadow: 0 1px 5px rgba(38, 144, 68, 0.13);\r\n}\r\n\r\n/* Muted child-count inside pill */\r\n.stree-count {\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    color: rgba(38, 144, 68, 0.55);\r\n    letter-spacing: 0.01em;\r\n}\r\n\r\n/* ── Property count badge ─────────────────────────────────────────────────── */\r\n.stree-prop-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    background: #f3f3f3;\r\n    border: 1px solid #d8d8d8;\r\n    border-radius: 5px;\r\n    padding: 3px 9px;\r\n    font-size: 11px;\r\n    color: #909090;\r\n    font-weight: 600;\r\n    cursor: default;\r\n    user-select: none;\r\n    transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.stree-prop-badge:hover {\r\n    background: #eaeaea;\r\n    border-color: #bbb;\r\n    color: #666;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
